module.exports = __webpack_public_path__ + "assets/img/capitalist.6aefd5e6.svg";